import * as React from 'react';
import { Card, Col, Row, Form, Container } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { getCourse } from "../../api/studentDetails"

function CouresChoiceDetails({ formData, setFormData, closedCourses, errors, setErrors }) {
    console.log("Closed Courses in CouresChoiceDetails:", closedCourses);
    const [error, setError] = useState('');

    const token =
        typeof window !== "undefined" ? localStorage.getItem("token") : null;

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const [courseResponse] = await Promise.all([
                    getCourse(token),
                ]);

                setFormData((prevData) => ({
                    ...prevData,
                    courseid: courseResponse.data || []

                }));

            } catch (error) {
                setError("Error fetching data:", error);
            }
        };
        fetchInitialData();
    }, [token, setFormData]);

     const handleCourseChange = (e) => {
        const selectedCourse = e.target.value;
        setFormData((prevData) => ({
            ...prevData,
            selectedCourse: selectedCourse,
        }));
        // Clear error when user selects a course
        if (selectedCourse) {
            setErrors(prev => ({ ...prev, courseDetails: {} }));
        }
    };
    return (
        <>
            <Container fluid>
                <Row className='mt-4'>
                    <Col>
                        <Card>
                            <div style={{ textAlign: "center" }}>
                                <Form.Label style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}
                                    className='mb-3  mt-2'>Course Choice</Form.Label>
                            </div>
                            <Card.Body>
                                <Form>
                                    <Row>
                                        <Col xl={6} lg={6} md={6} xs={12} s={12}>
                                            <Row className="mb-2">
                                                <Form.Group as={Row} className="mb-3">
                                                    <Form.Label column sm="3">
                                                        Course Choice<span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Col sm="7">
                                                        <Form.Select
                                                            id="selectedCourse"
                                                            required
                                                            value={formData.selectedCourse}
                                                            name="selectedCourse"
                                                            onChange={handleCourseChange}
                                                            // onChange={(e) =>
                                                            //     setFormData((prevData) => ({
                                                            //         ...prevData,
                                                            //         selectedCourse: e.target.value,
                                                            //     }))
                                                            // }
                                                        >
                                                            <option value="">Select Course</option>
                                                            {formData.courseid.map((course) => (
                                                                <option
                                                                    key={course.id}
                                                                    value={course.id}
                                                                    disabled={closedCourses.includes(course.id)}

                                                                >
                                                                    {course.courseName}
                                                                </option>
                                                            ))}
                                                        </Form.Select>
                                                        {errors.courseDetails?.selectedCourse && (
                                                            <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                {errors.courseDetails.selectedCourse}
                                                            </div>
                                                        )}
                                                    </Col>
                                                </Form.Group>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default CouresChoiceDetails;